export default {
	"VUE_APP_VERSION": "5.0.1.0-rc.1",
	"VUE_APP_LMS_NAME": "MyLearning | DEV",
	"VUE_APP_BASE_URL": "https://devcurrys.academypoint.net/",
	"VUE_APP_API_URL": "https://devcurrysapi.academypoint.net/",
	"VUE_APP_CDN_URL": "https://devcurryscdn.academypoint.net/",
	"VUE_APP_ACADEMY_ADMIN_URL": "https://devcurrys.academypoint.net/admin",
	"VUE_APP_ROUTER_MODE": "history",
	"VUE_APP_STORAGE": "sessionStorage",
	"VUE_APP_COLLECT_LOCATION_INFO": 0,
	"VUE_APP_TERMS_AND_CONDITIONS_URL": "https://devcurrysapi.academypoint.net/data/SiteDocuments/{{userLang}}/termsAndConditions.pdf",
	"VUE_APP_PROFILE_IMAGE_SIZE_MB": 5,
	"VUE_APP_SCORM_RESULT_DELAY": 3000,
	"VUE_APP_FALLBACK_LANG": "en-GB",
	"VUE_APP_RAYGUN_ENABLE_CRASHREPORTING": false,
	"VUE_APP_RAYGUN_ENABLE_PULSE": false,
	"VUE_APP_RAYGUN_API_KEY": "",
	"VUE_APP_OPENID": {
	  "REDIRECT_URI": "https://devcurrys.academypoint.net/oidc-callback",
	  "SILENT_REDIRECT_URI": "https://devcurrys.academypoint.net/silent-renew-oidc.html",
	  "POST_LOGOUT_REDIRECT_URI": "https://devcurrys.academypoint.net/oidc-loggedout",
	  "AUTHORITY": "https://devcurrysapi.academypoint.net",
	  "CLIENT_ID": "Cirrus.AcademyPointAPI",
	  "RESPONSE_TYPE": "code",
	  "SCOPE": "openid email profile offline_access",
	  "ACCESSTOKENEXPIRINGNOTIFICATIONTIME": 60,
	  "CLOCKSKEW": 300,
	  "AUTOMATICSILENTRENEW": true,
	  "SILENTREQUESTTIMEOUT": 10000,
	  "MONITORSESSION": true,
	  "CHECKSESSIONINTERVAL": 2000,
	  "STALESTATEAGE": 300,
	  "LOADUSERINFO": false,
	  "LOGGING": false,
	  "EXEC_PROVIDERLOGOUT": true,
	  "STORAGE": "sessionStorage"
	},
	"VUE_APP_EMERALD_WORKS_AUTHORITY": "https://identity-currys-saml.academypoint.net",
	"VUE_APP_EMERALD_WORKS_CLIENT_ID": "AP-Currys-PW",
	"VUE_APP_USE_CLIENT_ROUTER": true
}